import { Box, BoxProps } from '@mui/material';

export const Flex = ({ children, ...props }: BoxProps) => (
    <Box display="flex" alignItems="center" justifyContent="space-between" {...props}>
        {children}
    </Box>
);

export const FlexItem = ({ children, sx, ...props }: BoxProps) => (
    <Box sx={{ ...sx }} {...props}>
        {children}
    </Box>
);

export const Grid = ({ children, ...props }: BoxProps) => (
    <Box display="grid" {...props}>
        {children}
    </Box>
);
